module.exports = __webpack_public_path__ + "img/understand_mobile.12cea017.png";